import React from "react";
import PropTypes from "prop-types";
import { EVENT_CODE_ENTER } from "../../constants";

/**
 * Contract Holder Program Performance "Click for more info" Link Component
 * @param {Object} props
 * @param {function} props.handleClick
 * @param {string} actionType
 * @returns {Element}
 * @constructor
 */
export default function MoreInfoLink({ handleClick, actionType }) {
  return <div role="button" className="more-info-link" tabIndex={0} title="Click for more info"
              onClick={(event) => {
                handleClick(actionType, event);
              }}
              onKeyDown={(event) => {
                if (event.key === EVENT_CODE_ENTER) {
                  handleClick(actionType, event);
                }
              }}>
    Click for more info
  </div>;
}

MoreInfoLink.propTypes = {
  handleClick: PropTypes.func.isRequired, actionType: PropTypes.string.isRequired
};